import React from 'react';
import { Filter as RAFilter } from 'react-admin';

const Filter = ({ variant = 'outlined', ...props }) => (
	<RAFilter {...props} />
);

export default Filter;